import Vue from 'vue'
import Vuex from 'vuex'
import webSocket from './modules/socket'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isShowLoading: false, // 全局 loading
    },
    actions: {
    },
    modules: {
        webSocket
    },
    mutations: {
        setLoading(state, isShowLoading) {
            state.isShowLoading = isShowLoading
        },

    },
})

export default store
